import { render, staticRenderFns } from "./SuccessOrder.vue?vue&type=template&id=46c42b29&scoped=true&"
import script from "./SuccessOrder.vue?vue&type=script&lang=js&"
export * from "./SuccessOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c42b29",
  null
  
)

export default component.exports